import type {Person} from "@/scripts/Common";

const createNewPerson = () => {
    const person: Person = {
        id: 0,
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: ''
    }

    return person;
}

const personFullName = (person: Person) => {
    const firstName = person.firstName ?? '';
    const lastName = person.lastName ?? '';

    if (firstName !== '' && lastName !== '') return `${lastName}, ${firstName}`;

    return firstName || lastName;
}

const resetPersonObject = (originalObject: Person, changedObject: Person) => {
    changedObject.id = originalObject.id;
    changedObject.firstName = originalObject.firstName;
    changedObject.lastName = originalObject.lastName;
    changedObject.phoneNumber = originalObject.phoneNumber;
    changedObject.email = originalObject.email;
}

const personHasChanges = (originalObject: Person, changedObject: Person) => {
    return changedObject.id !== originalObject.id
        || changedObject.firstName !== originalObject.firstName
        || changedObject.lastName !== originalObject.lastName
        || changedObject.phoneNumber !== originalObject.phoneNumber
        || changedObject.email !== originalObject.email;
}

export {
    createNewPerson,
    resetPersonObject,
    personHasChanges,
    personFullName
}
